/**
 *  @since: 2020-05-11
 *  @author: tams_dev1
 */

import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  txtExceptionListUrl: '/api/op/as/exceptions',
  txtExceptionListCommitUrl: '/api/op/as-exceptions',
  // 선택한 row 데이터
  rowSelectItems: {},
  rowSelectItemsSubTable: {},
  getExceptionListData: [],
  getMailAddrData: []
})

export const mutations = {
  clearStore: (state) => {
    state.rowSelectItems = {}
    state.rowSelectItemsSubTable = {}
    state.getExceptionListData = []
    state.getMailAddrData = []
  },
  setRowSelectItems: (state, data) => {
    state.rowSelectItems = _.cloneDeep(data)
  },
  setRowSelectItemsSubTable: (state, data) => {
    state.rowSelectItemsSubTable = _.cloneDeep(data)
  },
  subTableHeaderMutation: (state, data) => {
    state.getMailAddrData = _.map(state.getMailAddrData, (item) => {
      item.excpt_mail_use = data
      return item
    })
  },
  getExceptionListDataAction: (state, data) => {
    state.getExceptionListData = _.cloneDeep(data)
  },
  addExceptionListDataAction: (state, data) => {
    state.getExceptionListData.push(data)
  },
  editExceptionListDataAction: (state, data) => {
    state.getExceptionListData = _.map(state.getExceptionListData, (item) => {
      if (item.excpt_mail_list_id === data.excpt_mail_list_id) {
        item.excpt_mail_list_uname = _.cloneDeep(data.excpt_mail_list_uname)
        item.excpt_mail_list_desc = _.cloneDeep(data.excpt_mail_list_desc)
      }
      return item
    })
  },
  getMailAddrDataAction: (state, data) => {
    state.getMailAddrData = _.cloneDeep(data)
  },
  addSubTable: (state, data) => {
    state.getMailAddrData.push(data)
  },
  editSubTable: (state, data) => {
    state.getMailAddrData = _.map(state.getMailAddrData, (item) => {
      if (item.excpt_mail_id === data.excpt_mail_id) {
        item.excpt_mail_use = _.cloneDeep(data.excpt_mail_use)
        item.excpt_mail_direct = _.cloneDeep(data.excpt_mail_direct)
        item.excpt_mail_addr = _.cloneDeep(data.excpt_mail_addr)
        item.excpt_mail_ptrn_type = _.cloneDeep(data.excpt_mail_ptrn_type)
      }
      return item
    })
  }
}

export const actions = {
  // 예외목록 조회
  async getExceptionListDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtExceptionListUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getExceptionListDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 예외목록 추가
  async addExceptionListDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(state.txtExceptionListUrl, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addExceptionListDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 예외목록 수정
  async editExceptionListDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtExceptionListUrl}/${state.rowSelectItems[0].excpt_mail_list_id}`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editExceptionListDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 예외목록 삭제
  async delExceptionListDataAction ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItems.length > 1) {
      isMulty = true
      state.rowSelectItems.forEach((item) => {
        idList.push({'excpt_mail_list_id': item.excpt_mail_list_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(state.txtExceptionListUrl, {data: {items: idList}}, {failAlert: false}) : await this.$axios.$delete(`${state.txtExceptionListUrl}/${state.rowSelectItems[0].excpt_mail_list_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 예외메일목록 조회
  async getMailAddrDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.txtExceptionListUrl}/${state.rowSelectItems[0].excpt_mail_list_id}/items`)
      return resultFactory(commit, {length: null, data: data, action: 'getMailAddrDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 예외메일목록 추가
  async addSubTable ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${state.txtExceptionListUrl}/${state.rowSelectItems[0].excpt_mail_list_id}/items`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addSubTable', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 예외메일목록 수정
  async editSubTable ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtExceptionListUrl}/${state.rowSelectItems[0].excpt_mail_list_id}/items/${state.rowSelectItemsSubTable[0].excpt_mail_id}`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editSubTable', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 예외메일 일괄수정
  async editAllSubTable ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtExceptionListUrl}/${state.rowSelectItems[0].excpt_mail_list_id}/items`, {items: payload}, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 예외메일목록 삭제
  async delSubTable ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItemsSubTable.length > 1) {
      isMulty = true
      state.rowSelectItemsSubTable.forEach((item) => {
        idList.push({'excpt_mail_list_id': state.rowSelectItems[0].excpt_mail_list_id, 'excpt_mail_id': item.excpt_mail_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.txtExceptionListUrl}/${state.rowSelectItems[0].excpt_mail_list_id}/items`, {data: {items: idList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.txtExceptionListUrl}/${state.rowSelectItems[0].excpt_mail_list_id}/items/${state.rowSelectItemsSubTable[0].excpt_mail_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 예외목록 적용/취소
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.txtExceptionListCommitUrl}/${type}`, null, msg)
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
